import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const showPagination = (size, current, route) => {
  console.log("pagination size", size);
  const arr = [...Array(size).keys()].reverse();
  if (size <= 1) {
    return null;
  }
  return arr.map((val, index) => {
    const currentIndexStyle = val + 1 == current ? { background: "#e96c5b", color: "#fff" } : null;
    return (
      <div className="" key={val}>
        <nav aria-label="Page navigation">
          <ul className="pagination">
            <li className="page-item">
              <Link to={route + (val + 1)} className="page-link" style={currentIndexStyle}>
                {val + 1}
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    );
  });
};

const Pagination = props => {
  return (
    <React.Fragment>
      {showPagination(props.numberOfPages, props.currentPage, props.route)}
    </React.Fragment>
  );
};

Pagination.propTypes = {
  numberOfPages: PropTypes.number.isRequired,
  route: PropTypes.string.isRequired,
  currentPage: PropTypes.number
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Pagination.js